import React, { useEffect, useState } from "react";
import "./UserManagement.css";
import Swal from "sweetalert2";
import { BASE_URL } from "./apiConfig";

export default function UserManagement() {
    const [activeTab, setActiveTab] = useState("user");
    const [showApiPassword, setShowApiPassword] = useState(false);
    const [showGuiPassword, setShowGuiPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [inputGUIValue, setGUIInputValue] = useState('');
    const [apikey, setAPIKEYValue] = useState('');
    const [password, setPassword] = useState('');
    const [GUIpassword, setGUIPassword] = useState('');
    const [showprogress, setshowprogress] = useState(false);
    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusername = loginData?.guiuserid;
    const sessionusertype = loginData?.utype?.usertype;

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (/^[a-zA-Z0-9.]*$/.test(value) && value.length <= 45) {
            setInputValue(value);
        }
    };

    const handleGUIInputChange = (event) => {
        const value = event.target.value;
        if (/^[a-zA-Z0-9.]*$/.test(value) && value.length <= 45) {
            setGUIInputValue(value);
        }
    };

    const handleAPIKEYChange = (event) => {
        const value = event.target.value;
        // Only allows alphanumeric characters (no spaces)
        if (/^[a-zA-Z0-9]*$/.test(value)) {
            setAPIKEYValue(value);
        }
    };

    const callAddSeller = async () => {
        if (!inputValue || !GUIpassword) {
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please Fill in all fields [ Seller or Password ] as some field is not inputted",
                icon: "error"
            })
        }

        else {
            
                        setshowprogress(true);
                        const apiUrl = `${BASE_URL}/AddSeller`;
            
                        const requestBody = {
                            guiuserid: inputValue,
                            guipassword: GUIpassword,
                            
                        };
                        const fetchOptions = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestBody),
                        };
            
                        try {
                            const response = await fetch(apiUrl, fetchOptions);
                            if (!response.ok) {
                                const errorMessage = response.statusText;
                                const responseBody = await response.text();
                                setshowprogress(false);
                                const result = await Swal.fire({
                                    title: 'Insertion Error',
                                    html: `${errorMessage}${responseBody}`,
                                    icon: 'error'
                                });
                            }
            
                            const data = await response.json();
                           // console.log(data);
            
                            setshowprogress(false);
                            const result = await Swal.fire({
                                title: "Inserted Successfully!",
                                text: `Your New Seller:${inputValue} has been Created Successfully.`,
                                icon: "success"
                            });
            
                            if (result.isConfirmed) {
                                setInputValue('');
                                setGUIPassword('');
                            }
                        }
            
                        catch (error) {
                            console.error("API Request Error:", error.message);
                            setshowprogress(false);
                            setshowprogress(false);
                            Swal.fire({
                                title: 'API Request Error',
                                html: error.message,
                                icon: 'error'
                            });
                        }
        }
    };

     const CallAdduser = async () => {
            if (!inputValue || !inputGUIValue || !apikey || !password || !GUIpassword) {
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill in all fields [ apiusername, apipassword, guiusername, guipassword, platform Apikey] as some field is not inputted",
                    icon: "error"
                })
    
            }
    
            else if (apikey.length != 32) {
                const re = await Swal.fire({
                    title: "InValid Value Error!",
                    text: "Please Input Valid API Key [ Should contain 32 alphanumeric characters ]",
                    icon: "error"
                })
    
            }
    
            else {
    
                setshowprogress(true);
                const apiUrl = `${BASE_URL}/AddUser`;
    
                const requestBody = {
                    apiuserid: inputValue,
                    apipassword: password,
                    primarykey: apikey,
                    guiuserid: inputGUIValue,
                    guipassword: GUIpassword,
                    utype: {
                        usertype: 1
                    },
                    requser: sessionusername
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                };
    
                try {
                    const response = await fetch(apiUrl, fetchOptions);
                    if (!response.ok) {
                        const errorMessage = response.statusText;
                        const responseBody = await response.text();
                        setshowprogress(false);
                        const result = await Swal.fire({
                            title: 'Insertion Error',
                            html: `${errorMessage}${responseBody}`,
                            icon: 'error'
                        });
    
    
                    }
    
                    const data = await response.json();
                    console.log(data);
    
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: "Inserted Successfully!",
                        text: `Your New User with API username:${inputValue} and GUI username:${inputGUIValue} has been Inserted Successfully.`,
                        icon: "success"
                    });
    
                    if (result.isConfirmed) {
                        setInputValue('');
                        setGUIInputValue('');
                        setGUIPassword('');
                        setAPIKEYValue('');
                        setPassword('');
                    }
                }
    
                catch (error) {
                    console.error("API Request Error:", error.message);
                    setshowprogress(false);
                    setshowprogress(false);
                    Swal.fire({
                        title: 'API Request Error',
                        html: error.message,
                        icon: 'error'
                    });
                }
            }
        };

    useEffect(() => {
        setGUIPassword("");
        setInputValue("");
    }, [activeTab])

    return (
        <div className="user-management-container">
            <div className="user-management-header">
                <h2>User Management</h2>
                <p>Create Seller and API / GUI users</p>
            </div>

            <div className="user-management-tabs">
                {sessionusertype === 0 && (
                    <button
                    className={activeTab === "seller" ? "active" : ""}
                    onClick={() => setActiveTab("seller")}
                >
                    Seller Creation
                </button>
                )}

                <button
                    className={activeTab === "user" ? "active" : ""}
                    onClick={() => setActiveTab("user")}
                >
                    User Creation
                </button>
            </div>

            {activeTab === "seller" ? (
                <div className="creation-panel">

                    <div className="form-grid seller-grid">

                        <div className="form-field">
                            <label>Seller Username</label>

                            <div className="input-with-icon">
                                <input
                                    type="text"
                                    placeholder="Enter Seller Username"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                />

                                <span className="input-icon">
                                    <i className="fa fa-user"></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>Seller Password</label>

                            <div className="input-with-icon">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter Seller password"
                                    value={GUIpassword}
                                    onChange={(e) => setGUIPassword(e.target.value)}
                                />

                                <span
                                    className="input-icon clickable"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <i
                                        className={
                                            showPassword
                                                ? "fa fa-eye-slash"
                                                : "fa fa-eye"
                                        }
                                    ></i>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="form-actions">
                        <button className="primary-btn" onClick={callAddSeller}>
                            Create Seller
                        </button>
                    </div>

                </div>
            ) : (
                <div className="creation-panel">

                    <div className="form-grid">

                        <div className="form-field">
                            <label>API Username</label>

                            <div className="input-with-icon">
                                <input
                                    type="text"
                                    placeholder="Enter API Username"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                />

                                <span className="input-icon">
                                    <i className="fa fa-user"></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>API Password</label>

                            <div className="input-with-icon">
                                <input
                                    type={showApiPassword ? "text" : "password"}
                                    placeholder="Enter API User password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />

                                <span
                                    className="input-icon clickable"
                                    onClick={() =>
                                        setShowApiPassword(!showApiPassword)
                                    }
                                >
                                    <i
                                        className={
                                            showApiPassword
                                                ? "fa fa-eye-slash"
                                                : "fa fa-eye"
                                        }
                                    ></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>Platform API Key</label>

                            <div className="input-with-icon">
                                <input
                                    type="text"
                                    placeholder="Enter Platform API Key"
                                    value={apikey}
                                    onChange={handleAPIKEYChange}
                                />

                                <span className="input-icon">
                                    <i className="fa fa-key"></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>GUI Username</label>

                            <div className="input-with-icon">
                                <input
                                    type="text"
                                    placeholder="Enter GUI Username"
                                    value={inputGUIValue}
                                    onChange={handleGUIInputChange}
                                />

                                <span className="input-icon">
                                    <i className="fa fa-user-circle"></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>GUI Password</label>

                            <div className="input-with-icon">
                                <input
                                    type={showGuiPassword ? "text" : "password"}
                                    placeholder="Enter GUI User password"
                                    value={GUIpassword}
                                    onChange={(e) => setGUIPassword(e.target.value)}
                                />

                                <span
                                    className="input-icon clickable"
                                    onClick={() =>
                                        setShowGuiPassword(!showGuiPassword)
                                    }
                                >
                                    <i
                                        className={
                                            showGuiPassword
                                                ? "fa fa-eye-slash"
                                                : "fa fa-eye"
                                        }
                                    ></i>
                                </span>
                            </div>
                        </div>


                        <div className="form-field">
                            <label>User Type</label>

                            <div className="input-with-icon">
                                <select defaultValue="user" disabled={true} style={{background:"#bdbcbc"}}>
                                    <option value="" disabled>
                                        Select User
                                    </option>
                                    <option value="admin">Admin</option>
                                    <option value="dealer">Dealer</option>
                                    <option value="user">User</option>
                                </select>

                                <span className="input-icon">
                                    <i className="fa fa-building"></i>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="form-actions">
                        <button className="primary-btn" onClick={CallAdduser}>
                            Add User
                        </button>
                    </div>

                </div>
            )}

        </div>
    );
}